import styled, { css } from 'styled-components'
import {
  SUMMER_SKY,
  LIGHT_BLUE,
  WHITE,
  BLACK,
  BLACK_RGB,
} from 'constants/colors'
import { Flex, truncateStyles } from 'components/common/styles'

export const Image = styled.li<{
  active: boolean
  imageUrl: string
  disabled: boolean
}>`
  display: flex;
  justify-content: space-between;
  align-items: start;
  flex-direction: column;
  border-radius: 8px;
  padding: 3px 3px 7px 3px;
  aspect-ratio: 1;
  background-image: ${({ active }) =>
      active &&
      `linear-gradient(
      rgba(35, 187, 239, 0.2), 
      rgba(35, 187, 239, 0.2)
    ),`}
    url(${({ imageUrl }) => imageUrl});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  ${({ active, disabled }) =>
    active
      ? css`
          box-shadow: inset 0 0 0 3px ${SUMMER_SKY};
        `
      : !disabled &&
        css`
          &:hover {
            box-shadow: inset 0 0 0 3px ${LIGHT_BLUE};
          }
        `}
`

export const ImagesContainer = styled.ul<{ shouldWrap: boolean }>`
  padding: 0;
  margin: 0;

  ${({ shouldWrap }) =>
    shouldWrap
      ? css`
          display: grid;
          grid-template-columns: 50% 50%;

          li:nth-child(even) {
            margin: 0 0 8px 4px;
          }

          li:nth-child(odd) {
            margin: 0 4px 8px 0;
          }
        `
      : css`
          display: flex;
          justify-content: space-between;
          overflow: auto;

          li {
            margin-right: 8px;
            min-width: 167.5px;
            min-height: 167.5px;
          }
        `}
`

export const ImageTitle = styled.span`
  line-height: 20px;
  font-weight: 500;
  color: ${WHITE};
  padding: 9px;
  max-width: 100%;
  ${truncateStyles}
`

export const ImageHeader = styled(Flex)`
  width: 100%;

  .Mui-checked {
    color: rgba(${BLACK_RGB}, 0.54);
  }

  .MuiRadio-root,
  .MuiCheckbox-root {
    padding: 0;
    width: 43px;

    &:hover {
      background-color: rgba(${BLACK_RGB}, 0.04);
    }
  }
`

export const DialogBody = styled(Flex)`
  overflow: hidden;
  color: ${WHITE};
  margin: 0;
  max-width: 100vw;
  width: 100%;
`

export const DialogBackdrop = styled.div`
  position: fixed;
  background-color: ${BLACK};
  opacity: 0.9;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
`

export const FullSizeImage = styled(Flex)<{
  isFirstImage: boolean
  isLastImage: boolean
  isMobileView: boolean
}>`
  margin: 0 50px;
  overflow: hidden;
  word-break: break-word;
  max-width: min-content;
 
  > img {
    max-height: calc(100vh - 290px);
    margin: auto;
    max-width: 100vw;
  }

  ${({ isFirstImage }) =>
    isFirstImage &&
    css`
      margin-left: 98px;
    `}

  ${({ isLastImage }) =>
    isLastImage &&
    css`
      margin-right: 98px;
    `}
 
  ${({ isMobileView }) =>
    isMobileView &&
    css`
      margin: 0;
    `}
`

export const FullSizeHeader = styled.div<{ isMobileView?: boolean }>`
  margin: 0 0 30px auto;

  ${({ isMobileView }) =>
    isMobileView &&
    css`
      position: fixed;
      top: 0;
      right: 0;
      padding: 20px 16px 0;
    `}

  > button {
    margin: 0 0 0 16px;
    padding: 0;

    &:hover {
      background-color: rgba(255, 255, 255, 0.4);
    }
  }
`
export const FullSizeTitle = styled.span`
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  margin: 16px 0 4px;
  overflow: hidden;
  max-height: 26px;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
`

export const FullSizeDescription = styled.span`
  font-size: 16px;
  line-height: 22px;
  overflow: hidden;
  max-height: 88px;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 4;
`

export const StyledIconButton = styled.div`
  > button {
    padding: 9px;
  }
`

export const ArrowIconButton = styled.div<{
  $isMobileView: boolean
  $isLeft?: boolean
}>`
  > button {
    ${({ $isMobileView }) =>
      $isMobileView &&
      css`
        position: fixed;
      `}

    ${({ $isLeft }) =>
      $isLeft
        ? css`
            left: 0;
          `
        : css`
            right: 0;
          `}

    &:hover {
      background-color: ${({ $isMobileView }) =>
        $isMobileView ? 'transparent' : 'rgba(255, 255, 255, 0.4)'};
    }
  }
`

export const ImageInfoContainer = styled(Flex)<{ isMobileView: boolean }>`
  min-width: ${({ isMobileView }) =>
    isMobileView ? 'calc(100vw - 25px)' : '600px'};

  ${({ isMobileView }) =>
    isMobileView &&
    css`
      margin: 0 16px;
    `}
`
